/* eslint-disable react/jsx-no-target-blank */
import {useEffect, useState} from 'react'
import {ILayout, useLayout} from '../../core'
import {API_URL} from '../../../../app/config/api.config'
import {WhatsNew} from '../../../../app/components/whats-new/WhatsNew'

const Footer = () => {
  const {config} = useLayout()
  const [appVersion, setAppVersion] = useState('')

  useEffect(() => {
    updateDOM(config)
  }, [config])

  useEffect(() => {
    fetch(`${API_URL}/api/setup/version`)
      .then((res) => res.json())
      .then((data) => {
        if (data.version) setAppVersion(data.version)
      })
      .catch(() => {})
  }, [])

  return (
    <>
      <div className='text-dark order-2 order-md-1'>
        <span className='text-muted fw-semibold me-1'>
          {new Date().getFullYear().toString()}&copy;
        </span>
        <a
          href='https://www.revcontech.com/'
          target='_blank'
          className='text-gray-800 text-hover-primary'
        >
          RevCon Outpost
        </a>
        {appVersion && (
          <span className='text-gray-400 fs-9 ms-2'>v{appVersion}</span>
        )}
      </div>
      <div className='order-1 order-md-2'>
        <WhatsNew />
      </div>
    </>
  )
}

const updateDOM = (config: ILayout) => {
  if (config.app?.footer?.fixed?.desktop) {
    document.body.classList.add('data-kt-app-footer-fixed', 'true')
  }

  if (config.app?.footer?.fixed?.mobile) {
    document.body.classList.add('data-kt-app-footer-fixed-mobile', 'true')
  }
}

export {Footer}
